import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-report-language-selection',
    templateUrl: './report-language-selection.component.html',
    styleUrls: ['./report-language-selection.component.scss'],
    standalone: false
})
export class ReportLanguageSelectionComponent {
    selectedLanguage = this.translateService.currentLang;

    constructor(
        public dialogRef: MatDialogRef<ReportLanguageSelectionComponent>,
        private translateService: TranslateService
    ) {}

    selectLanguage() {
        this.dialogRef.close(this.selectedLanguage);
    }

    protected changeLanguage(selectedLanguage: string | Event): void {
        if (typeof selectedLanguage === 'string') {
            this.selectedLanguage = selectedLanguage;
        } else {
            this.selectedLanguage = '';
        }
    }
}
